import { Box, Button, FormHelperText, Stack } from '@mui/material'
import PageSection from '../../Constants&Theme/PageSection'
import { ReadOnlyTextField } from '../../garvan-react/Components/ReadOnlyTextField'
import {
  useVesselContext,
  vesselDialogs,
} from '../../Contexts/Modules/SampleModule/VesselModule'
import { useUserContext } from '../../Contexts/UserConfig'
import { getCodeSetLabelLookup } from '../../Functions/CodeSetFns'
import { formatValueDateTime } from '../../Functions/FormatValues'
import { stackGap } from '../../Constants&Theme/Spacing'
import { DeleteForever, MoveDown, Print, Update } from '@mui/icons-material'
import { useMachineContext } from '../../Contexts/CurrentMachine'
import DestroyDialog from './Dialogs/DestroyDialog'
import DestroyConfirmDialog from './Dialogs/DestroyConfirmDialog'
import MoveDialog from './Dialogs/MoveDialog'
import MoveConfirmDialog from './Dialogs/MoveConfirmDialog'
import NewStatusDialog from './Dialogs/NewStatusDialog'
import NewStatusConfirmDialog from './Dialogs/NewStatusConfirmDialog'
import { useStuartMutate } from '../../APIs/Hooks/PhpAPIHooks'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useGlobalContext } from '../../Contexts/GlobalTriggers'
import { LoadingButton } from '@mui/lab'

function VesselInfoSection() {
  const { vesselQuery, setOpenDialog } = useVesselContext()
  const { playScanSound } = useGlobalContext()
  const { setMessage } = useMessagePopupContext()
  const { cardPrinter, officePrinter } = useMachineContext()
  const { loginConfig } = useUserContext()
  const { data: vessel, isLoading: vesselLoading } = vesselQuery

  const { mutate: print, isLoading } = useStuartMutate(
    `/printing/printVessel.php?DeviceID=${officePrinter}&VesselID=${vesselQuery.data?.VesselID}`,
    (data) => {
      if (data?.message) {
        setMessage({
          subject: 'Error',
          severity: 'warning',
          message: data.message,
        })
      }
    },
  )

  return (
    <PageSection
      title={'Vessel Information'}
      loading={vesselLoading}
    >
      <Stack
        width={1}
        gap={stackGap.col}
      >
        <Stack
          direction={'row'}
          width={1}
          gap={stackGap.row}
        >
          <ReadOnlyTextField
            label="Vessel ID"
            value={vessel?.VesselID || ''}
            fullWidth
          />
          <ReadOnlyTextField
            label="Vessel Type"
            value={getCodeSetLabelLookup(
              loginConfig,
              ['VesselTypeID'],
              vessel?.VesselType,
            )}
            fullWidth
          />
        </Stack>
        <Stack
          direction={'row'}
          width={1}
          gap={stackGap.row}
        >
          <ReadOnlyTextField
            label="Holding"
            value={getCodeSetLabelLookup(
              loginConfig,
              ['KV-Holdings'],
              vessel?.HoldingID,
            )}
            fullWidth
          />
          <ReadOnlyTextField
            label="Creation"
            value={formatValueDateTime(vessel?.DateCreated)}
            fullWidth
          />
        </Stack>
        <Stack
          direction={'row'}
          width={1}
          gap={stackGap.row}
        >
          <Box sx={{ verticalAlign: 'top', flex: 1 }}>
            <Button
              startIcon={<MoveDown />}
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => setOpenDialog(vesselDialogs.MOVE)}
            >
              Move Vessel
            </Button>
            <FormHelperText>Move to another holding</FormHelperText>
          </Box>
          <Box sx={{ verticalAlign: 'top', flex: 1 }}>
            <Button
              startIcon={<Update />}
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => setOpenDialog(vesselDialogs.STATUS)}
            >
              Update Status
            </Button>
            <FormHelperText>
              Change the status of all samples contained in this vessel
            </FormHelperText>
          </Box>
          <Box sx={{ verticalAlign: 'top', flex: 1 }}>
            <Button
              startIcon={<DeleteForever />}
              fullWidth
              variant="contained"
              color="error"
              onClick={() => setOpenDialog(vesselDialogs.DESTROY)}
              disabled={vessel?.Status === 'DES'}
            >
              Destroy Vessel
            </Button>
            <FormHelperText>
              Mark Vessel and all contained Vessels and Samples as Destroyed
            </FormHelperText>
          </Box>
          <Box sx={{ verticalAlign: 'top', flex: 1 }}>
            <LoadingButton
              loading={isLoading}
              startIcon={<Print />}
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => {
                if (!cardPrinter) {
                  setMessage({
                    subject: 'Missing Setting',
                    severity: 'warning',
                    message:
                      'Please select an office printer from the Settings page',
                  })
                } else {
                  playScanSound(true)
                  print()
                }
              }}
            >
              Print Vessel
            </LoadingButton>
            <FormHelperText>Print vessel manifest</FormHelperText>
          </Box>
        </Stack>
      </Stack>
      <DestroyDialog />
      <DestroyConfirmDialog />
      <MoveDialog />
      <MoveConfirmDialog />
      <NewStatusDialog />
      <NewStatusConfirmDialog />
    </PageSection>
  )
}

export default VesselInfoSection
